import * as t from '../action_types';

// Support-inbox slice. Follows the house generic key-value setter pattern:
// every write goes through set_support_variable(key, payload).
const initialState = {
  // bootstrap → left nav (teams, agents, tags, views, folder counts)
  bootstrap: { teams: [], agents: [], tags: [], views: [], folder_counts: {} },
  bootstrap_status: 'none',

  // conversation list (current folder scope)
  conversations: [],
  conversations_total: 0,
  conversations_open_count: 0,
  conversations_status: 'none',

  // active thread { conversation, timeline, notes, contact, previous_conversations }
  active_conversation: null,
  active_conversation_status: 'none',

  // action statuses
  reply_status: 'none',
  reply_result: null,
  create_conversation_status: 'none',
  create_conversation_result: null,
  patch_status: 'none',
  tags_status: 'none',
  note_status: 'none',
  save_view_status: 'none',
  delete_view_status: 'none',

  // search
  search_results: { conversations: [], messages: [] },
  search_status: 'none'
};

const set_support_variable = (state, payload) => ({
  ...state,
  [payload.key]: payload.payload
});

// Optimistically zero the matching row's unread_count. The markRead saga only
// refetches bootstrap folder counts, not the conversation list, so without this
// the row's unread dot/pill (driven by list data) would linger until the next
// list refetch. Cheaper and instant vs. an extra list round-trip.
const mark_support_read = (state, payload) => ({
  ...state,
  conversations: state.conversations.map((c) =>
    c.uuid === payload.uuid ? { ...c, unread_count: 0 } : c
  )
});

export default function (state = initialState, action) {
  switch (action.type) {
    case t.set_support_variable:
      return set_support_variable(state, action.payload);
    case t.mark_support_read:
      return mark_support_read(state, action.payload);
    case t.reset:
      return initialState;
    default:
      return state;
  }
}
